module.exports = __webpack_public_path__ + "img/multiple-users-silhouette.afdc399b.png";